export const Nav__links__data = [
    {
        id:1,
        link_name:"Home",
        
    },
    {
        id:2,
        link_name:"About",
        
    },
    {
        id:3,
        link_name:"Features",
        
    }, 
    {
        id:4,
        link_name:"Solutions",
        
    }
]
export const Progress__data = [
    {
        id:1,
        number:"3800+",
        text:"user Active"
    },
    {
        id:2,
        number:"230+",
        text:"Trusted by company"
    },
    {
        id:3,
        number:"$230M+",
        text:"Transaction"
    },

]
export const Business__data =[
    {
        id:1,
        star:"fas fa-star",
        title:"Rewards",
        description:"The best credit cards offer some tanstalizing combinations of promotions and prizes."
    },
    {
        id:2,
        star:"fas fa-check-circle",
        title:"100% Secured",
        description:"We take proactive steps make sure your information and transactions are secure"
    },
    {
        id:3,
        star:"fas fa-paper-plane",
        title:"Balance Transfer",
        description:"A blance transfer credit card can save you a lot of money in interest charges."
    }
]
export const Testemonial__card__data =[
    {
        id:1,
        qoute:'"',
        text:"Money is only a tool. It will take you wherever you wish, but it will not replace you as the driver.",
        client_image:"./assets/client1.jpg",
        client_name:"Ritik Rathour",
        client_profession:"Front End Developer"
    },
    {
        id:2,
        qoute:'"',
        text:"Money makes your life easier. If you're lucky to have it, you're lucky.",
        client_image:"./assets/client2.jpg",
        client_name:"Ravi Rastogi",
        client_profession:"Back End Developer"
    },
    {
        id:3,
        qoute:'"',
        text:"It is usually people in the money business, finance, and international trade that are really rich.",
        client_image:"./assets/client3.jpg",
        client_name:"Vivek Kumar",
        client_profession:"UI/UX Designer"
    }
]
export const Footer__list__one = [
    {
        id:1, 
        item:"Content"
    },
    {
        id:2, 
        item:"How it Works"
    },
    {
        id:3, 
        item:"Create"
    },
    {
        id:4, 
        item:"Explore"
    },
    {
        id:5, 
        item:"Terms & Services"
    }
]
export const Footer__list__two = [
    {
        id:1, 
        item:"Help Center"
    },
    {
        id:2, 
        item:"Partners"
    },
    {
        id:3, 
        item:"Suggestions"
    },
    {
        id:4, 
        item:"Blog"
    },
    {
        id:5, 
        item:"NewsLetter"
    }
]
export const Footer__list__three = [
    {
        id:1,
        item:"Our Partners"
    },
    {
        id:2,
        item:"Become a Partner"
    }
]